import { IwocaLogo } from '@iwoca/orion';

import styles from './LogoHeading.module.css';
import LogoHeadingContent from './LogoHeadingContent';
import { useGetBrandingQuery } from '../../lendingApi/lendingApiQueries';

const LogoHeading = () => {
  const { branding, isBrandingLoading } = useGetBrandingQuery();

  if (isBrandingLoading) {
    return (
      <div className={styles.container}>
        <div className={styles.logoContainer} data-testid="loading-logo" />
      </div>
    );
  }

  if (!branding) {
    return (
      <div className={styles.container}>
        <div className={styles.logoContainer}>
          <div data-testid="iwoca-logo">
            <IwocaLogo className={styles.iwocaLogo} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <LogoHeadingContent
      logo={branding.logo}
      signup_branding_type={branding.signup_branding_type}
      partner_name={branding.partner_name}
    />
  );
};

export default LogoHeading;
